import { useEmployeesStore } from '@/stores/employees';

export function useEmployeePhotos() {
  const employeesStore = useEmployeesStore();

  const attachEmployeePhotos = (items) => {
    if (!Array.isArray(items) || !employeesStore.employeesLoaded) {
      return items;
    }
    
    // Map through items and attach photo URLs
    return items.map(item => {
      const matchingEmployee = employeesStore.employeesList.find(
        emp => emp.employee_id === item.employee_id
      );
      
      return {
        ...item,
        employee_photo_url: matchingEmployee?.employee_photo_url || null
      };
    });
  };

  return {
    attachEmployeePhotos
  };
}
